import styled from 'styled-components';

export const Wrapper = styled.div`
    position: relative;

    #collapsableTextContent_expand {
        :before {
            position: absolute;
            bottom: 24px;
            left: 0;
            right: 0;
            height: 160px;
            background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
            content: '';
        }
    }

    #collapsableTextContent_collapse,
    #collapsableTextContent_expand {
        button {
            display: inline-flex !important;
            align-items: baseline;
        }

        svg {
            margin-right: 4px;
        }
    }
`;

export const Content = styled.div`
    max-height: ${props => props.maxHeight}px;
    overflow: hidden;
`;
